import Vue from "vue";
import Element from "element-ui";
import VueCountUp from "vue-countupjs";
import proto from "../utils/proto";
import filter from "../utils/filter";
import components from "../utils/components";

Vue.use(Element);
Vue.use(VueCountUp);

Vue.use(proto);
Vue.use(filter);
Vue.use(components);
